import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useSubmitTransactionHash } from "@/hooks/use-mutations";
import { handleError } from "@/lib/helper";
import { useModalStore } from "@/zustand/modalStore";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";

const SubmitTxHash = ({
  closeSheet,
  depositOrderId,
}: {
  closeSheet: () => void;
  depositOrderId: string;
}) => {
  const { openModal } = useModalStore();
  const queryClient = useQueryClient();
  const [txId, setTxId] = useState("");

  const { mutateAsync: submitTransactionHash, isPending: isSubmittingHash } =
    useSubmitTransactionHash({
      id: depositOrderId,
    });

  const handleConfirm = async () => {
    try {
      await submitTransactionHash({ transactionHash: txId });
      queryClient.invalidateQueries({
        queryKey: ["deposits"],
      });
      queryClient.invalidateQueries({
        queryKey: ["depositOrder"],
      });
      queryClient.invalidateQueries({
        queryKey: ["recentTransactions"],
      });
      openModal("success", { type: "deposit" });
      closeSheet();
    } catch (error) {
      handleError(error);
    }
  };
  return (
    <div>
      <div className="mt-6">
        <p className="mt-4 text-lg">Enter Transaction Hash</p>
        <p className="text-dark-text-300 text-xs">
          Enter Transaction hash to complete deposit
        </p>
        <h4 className="mt-4 text-xs">Enter Transaction Hash</h4>
        <Input
          value={txId}
          onChange={(e) => setTxId(e.target.value)}
          placeholder="Enter Transaction Hash"
          className="field-gradient-aux-4 text-dark-text-50 mt-1 h-11 text-xs"
        />
        <div className="bg-dark-card-5 border-gradient-aux-4 mt-4 rounded-lg px-4 py-2 text-[14px]">
          <h6>NOTE</h6>
          <p className="text-dark-warning-300 mt-1 font-semibold tracking-wide">
            Your transaction will not be approved until you input the correct
            transaction hash
          </p>
        </div>
        <Button
          disabled={!txId || isSubmittingHash}
          isLoading={isSubmittingHash}
          onClick={() => handleConfirm()}
          className="text-dark-text-50 bg-dark-primary-main hover:bg-dark-primary-main/80 mt-6 mb-8 w-full font-semibold"
        >
          Confirm
        </Button>
      </div>
    </div>
  );
};

export default SubmitTxHash;
